import { Currency } from "./components/ido-details/sale-widget/sale-widget";

export type ClaimrWidgetType = { token: string } | undefined;

export type UserKarma = {
  xpTokens: number;
  karma: number;
  karmaView: number;
};

export type UserRefLink = {
  ref_id: string;
};

export type UserNftToken = {
  data: {
    minted: boolean;
  };
};

export interface IPostReferralArgs {
  refId: string;
  idoId: string;
}

export interface IReferralLinkQueryArgs {
  idoId: string;
  address: string;
  name?: string;
  refPercent?: number;
}

export interface IReferralLinkResponse {
  refLink: string;
}

export enum PrizeType {
  KARMA = 'KARMA',
  FREE_SPIN = 'FREE_SPIN',
  ALPHA_NFT = 'ALPHA_NFT',
  NFT = 'NFT',
  USDT = 'USDT',
  TOKEN = 'TOKEN',
}

export enum PrizeCategory {
  COMMON = 'common',
  RARE = 'rare',
  LEGENDARY = 'legendary',
}

export interface IPrize {
  name: string;
  value: string;
  probability: number;
  category?: PrizeCategory;
  type?: PrizeType;
  quantity?: number;
  tokenConfig?: {
    address: string;
    chainId: number;
    decimals: number;
    symbol?: string;
    reserveId?: string;
  };
}

export interface ITicket {
  address: string;
  used: boolean;
  usedAt: string;
  createdAt: string;
}

export interface IRouletteEntity {
  _id: string;
  prizes: IPrize[];
  tickets: ITicket[];
  recepient: string;
}

export interface Slice {
  label: string;
  color: string;
}

/**
 * IMPORTANT: Static slices array for BASE VISUAL DISPLAY in the roulette wheel.
 *
 * Display Logic:
 * - These prizes are ALWAYS shown on the UI (10 static prizes)
 * - If backend sends a NEW prize not in this list → it gets ADDED (becomes 11th prize)
 * - Example: 10 static prizes + 1 new token from backend = 11 prizes displayed
 *
 * Win Logic:
 * - ONLY prizes from backend API can actually be won
 * - If backend sends only 1 prize → user sees 10 on UI but can win only that 1
 *
 * The frontend validates winnable prizes - see CaseOpener.tsx createSlicesFromPrizes()
 */
export const slices: Slice[] = [
  { label: "Extra Spin", color: "#FF70A6" },
  { label: "Token Airdrop", color: "#C084FC" },
  { label: "Jackpot", color: "#FF8A65" },
  { label: "AlphaPioneer NFT", color: "#2A9D8F" },
  { label: "15 USDT", color: "#2A9D8F" },
  { label: "XForge Phone", color: "#2A9D8F" },
  { label: "Xardian Node", color: "#2A9D8F" },
  { label: "Mr.Uni NFT", color: "#2A9D8F" },
  { label: "Butt NFT", color: "#82A0FF" },
  { label: "Jackpot", color: "#FF8A65" },
  { label: "AlphaPioneer NFT", color: "#2A9D8F" },
  { label: "15 USDT", color: "#2A9D8F" },
  { label: "XForge Phone", color: "#2A9D8F" },
  { label: "Xardian Node", color: "#2A9D8F" },
  { label: "Jackpot", color: "#FF8A65" },
  { label: "$15 in $oLYNX", color: "#2A9D8F" },
  { label: "Leg NFT", color: "#82A0FF" },
  { label: "+1200 Karma", color: "#5FC9F8" },
  { label: "+40000 Karma", color: "#FF70A6" },
  { label: "Jackpot", color: "#FF8A65" },
  { label: "Xardian Node", color: "#2A9D8F" },
  { label: "Jackpot", color: "#190e0b" },
  { label: "Leg NFT", color: "#82A0FF" },
  { label: "$15 in $oLYNX", color: "#2A9D8F" },
  { label: "15 USDT", color: "#2A9D8F" },
  { label: "Jackpot", color: "#FF8A65" },
  { label: "AlphaPioneer NFT", color: "#2A9D8F" },
  { label: "15 USDT", color: "#2A9D8F" },
  { label: "XForge Phone", color: "#2A9D8F" },
  { label: "+800 Karma", color: "#F4A261" },
  { label: "+1600 Karma", color: "#2A9D8F" },
  { label: "Horn NFT", color: "#82A0FF" },
  { label: "Xardian Node", color: "#2A9D8F" },
  { label: "$10 in $oLYNX", color: "#2A9D8F" },
  { label: "Jackpot", color: "#FF8A65" },
  { label: "Xardian Node", color: "#2A9D8F" },
  { label: "Mr.Uni NFT", color: "#2A9D8F" },
  { label: "Xardian Node", color: "#2A9D8F" },
  { label: "$10 in $oLYNX", color: "#2A9D8F" },
  { label: "+8000 Karma", color: "#F4A261" },
  { label: "+500 Karma", color: "#E9C46A" },
  { label: "+400 Karma", color: "#E9C46A" },
  { label: "AlphaPioneer NFT", color: "#2A9D8F" },
  { label: "$15 in $oLYNX", color: "#2A9D8F" },
  { label: "XForge Phone", color: "#2A9D8F" },
  { label: "Horn NFT", color: "#82A0FF" },
  { label: "Mr.Uni NFT", color: "#2A9D8F" },
];

export type NetworkOption =
  | "Base"
  | "Linea"
  | "BNB"
  | "Arbitrum"
  | "ETH"
  | "ImmutableZkEVM";

export const chainIdToNetwork: Record<number, NetworkOption> = {
  8453: "Base",
  59144: "Linea",
  56: "BNB",
  42161: "Arbitrum",
  1: "ETH",
  13371: "ImmutableZkEVM",
};

export interface NetworkSelectProps {
  selectedNetwork: NetworkOption;
  onChange: (value: NetworkOption) => void;
}

export const stableTokenAddresses: Record<
  NetworkOption,
  Record<Currency.USDC | Currency.USDT, `0x${string}`>
> = {
  Base: {
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    USDT: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
  },
  ETH: {
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    USDT: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
  },
  Arbitrum: {
    USDC: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
  },
  Linea: {
    USDC: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
    USDT: "0xA219439258ca9da29E9Cc4cE5596924745e12B93",
  },
  BNB: {
    USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    USDT: "0x55d398326f99059fF775485246999027B3197955",
  },
  ImmutableZkEVM: {
    USDC: "0x0000000000000000000000000000000000000000",
    USDT: "0x0000000000000000000000000000000000000000",
  },
};

export type TGetClaimrActivityParams = {
  platform: string;
  account: string;
  campaignIds: string[];
};

export interface Prize {
  name: string;
  value: string;
  probability: number;
  category?: PrizeCategory | string;
  type?: PrizeType | string;
  tokenConfig?: {
    address: string;
    chainId: number;
    decimals: number;
    symbol?: string;
    reserveId?: string;
  };
}

export interface SpinResult {
  prize: Prize;
  ticketId: string;
}

export type SpinResponse = SpinResult | SpinResult[];

export interface ITotalBalanceResponse {
  softCap: number;
  soldTokens: number;
  totalTokens: number;
}
